import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'
import type { PaymentMethodInfo } from '../GET/getCreditCards'

export type HydraAddCreditCardData = Omit<
  PaymentMethodInfo,
  'href' | 'methodDetails' | 'billToEmail' | 'billToPhone'
> & {
  methodDetails: {
    creditCardExpires: string
    creditCardNumber: string
    payer: string
  }
}

export type HydraAddCreditCardsResponse = {
  href: string
}

type Props = {
  cardAlias: string
  data: HydraAddCreditCardData
  hydraToken: string
}

export const HydraAddCreditCard = ({ cardAlias, data, hydraToken }: Props) => {
  const request: SendRequestType = {
    method: 'POST',
    url: `/customers/me/creditcardaliases/${cardAlias}`,
    token: hydraToken,
    data,
  }

  return httpTools.sendRequest<HydraAddCreditCardsResponse>(request)
}
